import { useGetApiV1ExamClassRoomDisciplinesStatus } from '@/shared/api/generated';
import { unwrapPagedResponse } from '@/shared/utils/unwrapPagedResponse';

/**
 * Hook para listar os status de disciplinas de turma disponíveis para filtro.
 *
 * @returns Lista de opções de status com estado de loading
 *
 * @example
 * ```tsx
 * const { options, isLoading } = useClassRoomDisciplinesStatus();
 * ```
 */
export function useClassRoomDisciplinesStatus() {
  const { data, isLoading } = useGetApiV1ExamClassRoomDisciplinesStatus();
  return { options: unwrapPagedResponse(data), isLoading } as const;
}
